<header *ngIf="!isNonLocalized" class="bg-white p-2 mb-2">
  <div class="container">
    <div class="row">
      <div class="col pt-1">
        <nb-icon icon="globe-outline"></nb-icon><label style="font-weight: bold" class="pl-1" i18n>Language</label>
      </div>
      <div class="col">
        <ng-select
          [(ngModel)]="language"
          fullWidth
          style="width: 100%"
          id="language"
          name="language"
          (change)="languageChange($event)"
          style="font-weight: bold"
        >
          <ng-option
            *ngFor="let language of translationLanguages | keyvalue : sortAlphabeticallyByValue"
            [value]="language.key"
          >
            {{ language.value }}
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>
</header>

<div class="container">
  <div class="row">
    <div *ngIf="isPersonalizedOffer" class="smartphone col">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div>
          <div class="personalized-offer-card">
            <div *ngFor="let item of elements" [ngSwitch]="item.tag" class="d-flex flex-row">
              <div
                class="image-container-offer"
                *ngSwitchCase="'img'"
                [nbSpinner]="isLoading"
                [nbSpinnerMessage]="loadingMessage"
                nbSpinnerStatus="info"
              >
                <img *ngIf="!isLoading" [src]="item.value" [alt]="item.alt" class="" style="height: 100%" />
              </div>
              <div class="d-flex align-items-center">
                <p *ngSwitchCase="'b'" class="p-3" style="font-size: 13px">
                  {{ item.value }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="smartphone col ml-2">
      <div class="content">
        <div class="scrollable-content">
          <div *ngFor="let item of elements" [ngSwitch]="item.tag" class="element-item">
            <p *ngSwitchCase="'p'">
              <span [innerHTML]="item.value"></span>
            </p>
            <div
              *ngSwitchCase="'img'"
              class="image-container"
              [style.height.px]="208"
              [nbSpinner]="isLoading"
              [nbSpinnerMessage]="loadingMessage"
              nbSpinnerStatus="info"
            >
              <img *ngIf="!isLoading" [src]="item.value" [alt]="item.alt" class="element-img" />
            </div>
            <h5 *ngSwitchCase="'b'" class="text-base font-bold mt-2">
              {{ item.value }}
            </h5>
            <p *ngSwitchCase="'warning'" class="text-danger">
              {{ item.value }}
            </p>
          </div>
          <div *ngIf="button" class="button-container">
            <button id="notification-button">
              {{ button }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
